import { useState, useEffect } from 'react';
import OrderCustomerFields from './OrderCustomerFields';

const OrderCustomerFieldsCollapsible = ({
  customerName,
  phone,
  customerAddress,
  onCustomerNameChange,
  onPhoneChange,
  onCustomerAddressChange,
  accentFocus,
  phoneRequired = true,
}) => {
  const hasData = Boolean(customerName.trim() || phone.trim() || customerAddress.trim());
  const [expanded, setExpanded] = useState(hasData);

  useEffect(() => {
    setExpanded(hasData);
  }, [hasData]);

  const fields = (
    <OrderCustomerFields
      variant="header"
      customerName={customerName}
      phone={phone}
      customerAddress={customerAddress}
      onCustomerNameChange={onCustomerNameChange}
      onPhoneChange={onPhoneChange}
      onCustomerAddressChange={onCustomerAddressChange}
      accentFocus={accentFocus}
      phoneRequired={phoneRequired}
    />
  );

  const summaryParts = [
    customerName.trim() || '—',
    phone.trim() || '—',
  ];
  if (customerAddress.trim()) {
    summaryParts.push(customerAddress.trim());
  }
  const collapsedSummary = hasData
    ? summaryParts.join(' · ')
    : 'Tap to enter customer details';

  return (
    <>
      <div className="hidden md:block">{fields}</div>
      <div className="md:hidden">
        {expanded ? (
          fields
        ) : (
          <button
            type="button"
            onClick={() => setExpanded(true)}
            className="w-full h-8 px-2.5 text-xs text-left text-gray-600 bg-white border border-gray-300 rounded-md truncate hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-slate-400"
          >
            {collapsedSummary}
          </button>
        )}
      </div>
    </>
  );
};

export default OrderCustomerFieldsCollapsible;
